export const registrationFields = {
    MATRICULATION_NUMBER: 'MATRICULATION_NUMBER',
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    EMAIL: 'EMAIL',
    ADDRESS: 'ADDRESS',
    COUNTRY: 'COUNTRY',
    DATE_OF_BIRTH: 'DATE_OF_BIRTH',
}

export const IntervalType = {
    WEEKLY: 'WEEKLY',
    BIWEEKLY: 'BIWEEKLY',
    MONTHLY: 'MONTHLY',
    MONTHLY_WEEKDAY: 'MONTHLY_WEEKDAY',
};
